export default "__VITE_ASSET__ae55be5c__"